// extracted by css-extract-rspack-plugin
export default {"content":"content--UZOBNs7ba_Qme2QB","logoWrapper":"logo-wrapper--jN7tbMiJmU9wR08B","logo":"logo--TYq9EDJAEzUNpTQy"};